export default __webpack_public_path__ + "static/media/evaluationCompletedImage.581386a4.png";